import { initDependencies, setupDependencies } from './app';
import '../shared/utils/fullscreenModalFix.css';

setupDependencies();

initDependencies();

const { runApp } = require('./services/runApp');
runApp();

// oxlint-disable-next-line typescript/no-explicit-any
if ((module as any).hot) {
  // oxlint-disable-next-line typescript/no-explicit-any
  (module as any).hot.accept();
}
